<div class="snack-bar">
    <div class="profile">
        <img id="icon" src="/assets/images/icons/snackbar/email1.svg" alt="">
        <p>Invite sent successfully!</p>
    </div>
</div>